import { Flex, Link } from '@chakra-ui/react';
import { useEffect } from 'react';
import { FaEnvelope, FaTwitter } from 'react-icons/fa';
import { usePageDataCache } from '../../hooks/usePageDataCache';
import { UserProfile } from '../../service/social';
import { FacebookIcon } from '../iconComponents/FacebookIcon';
import { KickIcon } from '../iconComponents/KickIcon';
import { TikTokIcon } from '../iconComponents/TikTokIcon';
import { TwitchIcon } from '../iconComponents/TwitchIcon';
import { YoutubeIcon } from '../iconComponents/YoutubeIcon';

interface SocialLinksProps {
    userProfile: UserProfile;
}

export const SocialLinks: React.FC<SocialLinksProps> = ({ userProfile }) => {
    const localStoragePrefix = 'SocialLinks';

    const [twitch, setTwitch] = usePageDataCache(`${localStoragePrefix}_twitch`, '');
    const [kick, setKick] = usePageDataCache(`${localStoragePrefix}_kick`, '');
    const [facebook, setFacebook] = usePageDataCache(`${localStoragePrefix}_facebook`, '');
    const [tiktok, setTiktok] = usePageDataCache(`${localStoragePrefix}_tiktok`, '');
    const [google, setGoogle] = usePageDataCache(`${localStoragePrefix}_google`, '');
    const [twitter, setTwitter] = usePageDataCache(`${localStoragePrefix}_twitter`, '');
    const [email, setEmail] = usePageDataCache<string | undefined>(
        `${localStoragePrefix}_email`,
        undefined,
    );

    const twitchLength = Object.keys(twitch).length;
    const kickLength = Object.keys(kick).length;
    const googleLength = Object.keys(google).length;
    const tiktokLength = Object.keys(tiktok).length;
    const facebookLength = Object.keys(facebook).length;
    const twitterLength = Object.keys(twitter).length;

    useEffect(() => {
        const profile = userProfile;

        if (profile.social_media_links) {
            const socials = profile.social_media_links;

            if (socials.twitch && socials.twitch.is_public) {
                setTwitch(socials.twitch.handle);
            }
            if (socials.kick && socials.kick.is_public) {
                setKick(socials.kick.handle);
            }
            if (socials.facebook && socials.facebook.is_public) {
                setFacebook(socials.facebook.handle);
            }
            if (socials.tiktok && socials.tiktok.is_public) {
                setTiktok(socials.tiktok.handle);
            }
            if (socials.twitter && socials.twitter.is_public) {
                setTwitter(socials.twitter.handle);
            }
            if (socials.google && socials.google.is_public) {
                setGoogle(socials.google.handle);
            }
        }

        setEmail(profile.email);
    }, [userProfile]);

    return (
        <Flex className={'social-links'}>
            {twitchLength > 0 && (
                <Link href={`https://www.twitch.tv/${twitch}`} target={'_blank'}>
                    <TwitchIcon />
                </Link>
            )}
            {kickLength > 0 && (
                <Link href={`https://kick.com/${kick}`} target={'_blank'}>
                    <KickIcon />
                </Link>
            )}
            {googleLength > 0 && (
                <Link href={`https://www.youtube.com/${google}`} target={'_blank'}>
                    <YoutubeIcon />
                </Link>
            )}
            {facebookLength > 0 && (
                <Link href={`https://www.facebook.com/${facebook}`} target={'_blank'}>
                    <FacebookIcon />
                </Link>
            )}
            {twitterLength > 0 && (
                <Link href={`https://www.twitter.com/${twitter}`} target={'_blank'}>
                    <FaTwitter size={'50px'} />
                </Link>
            )}
            {tiktokLength > 0 && (
                <Link href={`https://www.tiktok.com/${tiktok}`} target={'_blank'}>
                    <TikTokIcon />
                </Link>
            )}
            {email && (
                <Link href={`mailto:${email}`} target={'_blank'}>
                    <FaEnvelope size={'50px'} />
                </Link>
            )}
        </Flex>
    );
};
